import { render, staticRenderFns } from "./SettingsWebhooks.vue?vue&type=template&id=513e2408"
import script from "./SettingsWebhooks.vue?vue&type=script&lang=js"
export * from "./SettingsWebhooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports